<template>
  <div>
    <server-error :error="error" />
    <div v-if="isLoaded">
      <div v-if="reportTableData !== null">
        <button class="b-btn mx-6" @click="exportReportData">
          <dynamic-icon class="b-btn__icon" icon="xls"></dynamic-icon>
          {{$t('CONTENT.reportPage.download_excel')}}
        </button>
        <div class="b-reports__table-wrapper">
          <div class="b-full-table b-reports__table-wrap mt-4">
            <!--          Шапка-->
            <div class="b-reports__table-header-wrap">
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.contract_code')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.lessor')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.lessor_type')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.contract_number')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.contract.contract_date')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.assets.lease_start_date')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.assets.lease_end_date')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.lease_month_count')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$tc('CONTENT.currency.currency_code', 1)}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.discountRates.discount_rate')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.inventory_number')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.asset_component')}}
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                 {{$t('CONTENT.reportPage.lease_liability_part')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_start_liability')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_initial_recognition_liability')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_increase')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_percentage_loss')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_decrease')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_lease_payments_in_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_accumulated_currency_rate_difference')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.lease_liability_part_end_liability')}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.additional_info_part')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.additional_info_part_remaining_lease_payments')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.additional_info_part_turnover_percentage')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="b-reports__table-content-wrap">
              <!--          Филиалы-->
              <div class="b-reports__table-row" v-for="item in reportTableData.rows">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractCode}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{getLessorName(item.lessorId)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{$t(`CONTENT.reportPage.${item.counterpartyType}`)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractNumber}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractDate | dateFormatted}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.leaseStartDate | dateFormatted}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.leaseEndDate | dateFormatted}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.leaseMonthCount}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{getFullCurrency(item.currencyRateType)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.discountRate}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.assetComponentId}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.assetName}} {{item.assetComponentName !== null ? ` - ${item.assetComponentName}` : ''}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.initialRecognitionLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.adjustmentIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.percentageLoss)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.leasePaymentsInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.accumulatedCurrencyRateDifference)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.leaseLiabilityPart.endLiability)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.additionalInfoPart.remainingLeasePayments)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.additionalInfoPart.turnoverPercentage)}}
                  </div>
                </div>
              </div>
              <!--          Итого-->
              <div class="b-reports__table-row b-reports__table-row-total">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.related_parties_total')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.initialRecognitionLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.adjustmentIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.percentageLoss)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.leasePaymentsInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.accumulatedCurrencyRateDifference)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.leaseLiabilityPart.endLiability)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.remainingLeasePayments)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.additionalInfoPart.turnoverPercentage)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total_for_third_party_companies')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.initialRecognitionLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.adjustmentIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.percentageLoss)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.leasePaymentsInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.accumulatedCurrencyRateDifference)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.leaseLiabilityPart.endLiability)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.remainingLeasePayments)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.additionalInfoPart.turnoverPercentage)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total_for_vgo')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.initialRecognitionLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.adjustmentIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.percentageLoss)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.leasePaymentsInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.accumulatedCurrencyRateDifference)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.leaseLiabilityPart.endLiability)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.remainingLeasePayments)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.additionalInfoPart.turnoverPercentage)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.startLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.initialRecognitionLiability)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.adjustmentIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.percentageLoss)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.leasePaymentsInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.accumulatedCurrencyRateDifference)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.leaseLiabilityPart.endLiability)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.remainingLeasePayments)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.additionalInfoPart.turnoverPercentage)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";
import { mapGetters } from "vuex";
import getFullCurrency from "../../../mixins/getFullCurrency";

export default {
  props: {
    dataForReport: {
      type: Object,
    },
  },
  data() {
    return {
      error: null,
      reportTableData: null,
      isHideLeasePaymentsGroupColumns: false,
      isHideInitialRecognitionColumns: false,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
      },
      deep: true
    },
  },
  mixins: [getFullCurrency],
  computed: {
    ...mapGetters(['allCounterparties']),
    ...mapGetters(['getUnderlyingAssetTypes']),
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getDecryptionReportBasedOnExpenses({
          periodStart: data.periodStart,
          periodEnd: data.periodEnd,
          contractId: data.contractId,
          lesseeId: data.lesseeId
        });
        this.$parent.nonActiveContractIds = this.reportTableData.nonActiveContractIds;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },

    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    async exportReportData() {
      this.error = null;
      try {
        const api = new ReportsAPI();
        const response = await api.exportResultOfDecryptionReportBasedOnExpenses(this.reportTableData);

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
    },
    getLessorName(lessorId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if(this.allCounterparties[i].idInDB === lessorId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    getAssetType(assetTypeId) {
      for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
        if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
          return this.getUnderlyingAssetTypes[i].name;
        }
      }
    },
  }
};
</script>
